import { Link } from "react-router-dom";
import { Eye, Flame } from "lucide-react";
import { useRadio } from "@/context/RadioContext";
import { NowHero } from "@/components/fo/NowHero";
import { Cover } from "@/components/fo/Bits";
import { fmtTime } from "@/lib/api";

const Item = ({ p, testid }) => (
  <div data-testid={testid} className="flex items-center gap-4 border-b border-white/5 py-3">
    <span className="w-12 font-mono text-xs text-slate-500">{fmtTime(p.start)}</span>
    <Cover src={p.cover} hidden={p.hidden} className="h-11 w-11 rounded-md" />
    <div className="min-w-0 flex-1">
      <div className="truncate font-display font-bold">{p.hidden ? "Blind Drop" : p.title}</div>
      <div className="truncate text-sm text-slate-400">{p.hidden ? "Artist hidden until it airs" : p.artist && <Link to={`/a/${p.artist.slug}`} className="hover:text-[#00F5D4]">{p.artist.stage_name}</Link>}</div>
    </div>
    {p.blind && <Eye className="h-4 w-4 text-[#FFB800]" />}
    {p.flames != null && <span className="flex items-center gap-1 font-mono text-sm text-[#FF2E63]"><Flame className="h-4 w-4" />{p.flames}</span>}
  </div>
);

export default function RadioPage() {
  const { state } = useRadio();
  return (
    <div data-testid="radio-page">
      <NowHero compact />
      <section className="mx-auto grid max-w-7xl gap-8 px-4 pb-24 md:grid-cols-2 md:px-8">
        <div className="panel p-6">
          <div className="label-mono mb-4">Up next</div>
          {state?.upcoming?.map((p) => <Item key={p.play_id} p={p} testid={`upcoming-${p.play_id}`} />)}
        </div>
        <div className="panel p-6">
          <div className="label-mono mb-4">Recently played</div>
          {state?.history?.map((p) => <Item key={p.play_id} p={p} testid={`history-${p.play_id}`} />)}
        </div>
      </section>
    </div>
  );
}
